<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <div>
            <div class="kgr-row">
                <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row">
                    <div class="kgr-postfix__fluid">
                        <kgr-view-picker
                            :value="view"
                            @post-input="updateView($event)"
                        />
                    </div>
                    <div class="kgr-postfix__fixed">
                        <kgr-print-button />
                    </div>
                </div>

                <div class="kgr-grid kgr-grid--columnGutters kgr-grid--inlineBlock">
                    <div class="kgr-grid__cell">
                        <kgr-member-status-picker
                            :statuses="statuses"
                            :types="types"
                            @post-input="updateStatuses"
                        />
                    </div>
                </div>
                <div class="kgr-grid kgr-grid--columnGutters kgr-row">
                    <div class="kgr-grid__cell">
                        <label class="kgr-inputGroup">
                            <div
                                v-t="'search'"
                                class="kgr-inputGroup__label"
                            ></div>
                            <input
                                v-model="search"
                                type="text"
                                class="kgr-input"
                            />
                        </label>
                    </div>
                    <div
                        v-if="view === 'grid'"
                        class="kgr-grid__cell animated fadeIn"
                    >
                        <label class="kgr-inputGroup">
                            <div
                                v-t="'sort'"
                                class="kgr-inputGroup__label"
                            ></div>
                            <kgr-sort-select
                                :value="sort"
                                @post-input="updateSort($event)"
                            />
                        </label>
                    </div>
                    <div class="kgr-grid__cell">
                        <div class="kgr-inputGroup__label">
&nbsp;
                        </div>
                        <kgr-button
                            v-t="'Suche starten'"
                            @click="load()"
                        />
                    </div>
                </div>
            </div>

            <kgr-members-list
                :members="members"
                :view="view"
                :can-load-more="canLoadMore"
                :loading="loading"
                @loadMore="loadMore"
            />
        </div>
    </kgr-form-scaffold>
</template>

<script>
import KgrButton from '../../components/common/form/button/KgrButton.vue';
import KgrFormScaffold from '../../components/common/form/FormScaffold';
import KgrMemberStatusPicker from '../../components/common/form/picker/MemberStatusPicker';
import MembersList from '../../components/members/MembersList';
import PrintButton from '../../components/common/form/button/PrintButton';
import SortSelect from '../../components/members/SortSelect';
import TeamRepository from '../../js/repository/TeamRepository';
import ViewPicker from '../../components/common/form/picker/ViewPicker';

const TEAM_MEMBERS_OVERVIEW_VIEW = 'kgr:team-members:overview:view';
const TEAM_MEMBERS_OVERVIEW_SORT = 'kgr:team-members:overview:sort';
const TEAM_MEMBERS_OVERVIEW_STATUSES = 'kgr:team-members:overview:contract-statuses';
const TEAM_MEMBERS_OVERVIEW_TYPES = 'kgr:team-members:overview:contract-types';

export default {
    components: {
        'kgr-member-status-picker': KgrMemberStatusPicker,
        'kgr-members-list': MembersList,
        'kgr-print-button': PrintButton,
        'kgr-sort-select': SortSelect,
        'kgr-view-picker': ViewPicker,
        'kgr-form-scaffold': KgrFormScaffold,
        'kgr-button': KgrButton,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        teamId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            members: null,
            search: '',
            sort: null,
            statuses: [0, 1, 2, 3],
            types: ['regular', 'passive', 'guest'],
            view: 'grid',
            timeout: null,
            limit: 100,
            offset: 0,
            canLoadMore: true,
        };
    },
    created() {
        const view = localStorage.getItem(TEAM_MEMBERS_OVERVIEW_VIEW);
        if (null !== view && '' !== view) {
            this.view = view;
        }
        const statuses = JSON.parse(localStorage.getItem(TEAM_MEMBERS_OVERVIEW_STATUSES));
        if (null !== statuses) {
            this.statuses = statuses;
        }
        const types = JSON.parse(localStorage.getItem(TEAM_MEMBERS_OVERVIEW_TYPES));
        if (null !== types) {
            this.types = types;
        }

        this.sort = localStorage.getItem(TEAM_MEMBERS_OVERVIEW_SORT);
    },
    mounted() {
        this.load();
    },
    methods: {
        updateView(view) {
            this.view = view;

            if (null !== view) {
                localStorage.setItem(TEAM_MEMBERS_OVERVIEW_VIEW, view);
            } else {
                localStorage.removeItem(TEAM_MEMBERS_OVERVIEW_VIEW);
            }
        },
        updateSort(sort) {
            this.sort = sort;

            if (null !== sort) {
                localStorage.setItem(TEAM_MEMBERS_OVERVIEW_SORT, sort);
            } else {
                localStorage.removeItem(TEAM_MEMBERS_OVERVIEW_SORT);
            }
        },
        updateStatuses(statusesAndTypes) {
            this.statuses = statusesAndTypes.statuses;
            this.types = statusesAndTypes.types;

            if (null !== this.statuses) {
                localStorage.setItem(TEAM_MEMBERS_OVERVIEW_STATUSES, JSON.stringify(this.statuses));
            } else {
                localStorage.removeItem(TEAM_MEMBERS_OVERVIEW_STATUSES);
            }

            if (null !== this.types) {
                localStorage.setItem(TEAM_MEMBERS_OVERVIEW_TYPES, JSON.stringify(this.types));
            } else {
                localStorage.removeItem(TEAM_MEMBERS_OVERVIEW_TYPES);
            }
        },
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        load() {
            this.loading = true;
            this.members = [];
            TeamRepository.findMembers(this.teamId, this.statuses.join(','), this.types.join(','), this.search, this.sort, this.limit, this.offset)
                .then(members => this.members = members)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => {
                    this.loading = false;
                });
        },
        loadMore() {
            this.offset += this.limit;
            this.loading = true;
            TeamRepository.findMembers(this.teamId, this.statuses.join(','), this.types.join(','), this.search, this.sort, this.limit, this.offset)
                .then(members => {
                    this.canLoadMore = members.length > 0;
                    this.members = this.members.concat(members);
                })
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
